import 'systemjs'
import 'systemjs/dist/extras/use-default.js'
import store from "@/store";

// 根据路径加载远程模块
let loadRemoteComponent  = async(remoteUrl,moduelName)=> {
    console.log('remoteUrl---',remoteUrl)
  console.log('moduelName--',moduelName)
  let container =  await System.import(remoteUrl);
  console.log('container',container);
  await __webpack_init_sharing__('default');
  await container.init(__webpack_share_scopes__.default);
  const factory = await container.get(`./${moduelName}`);
  console.log('factory--加载完成',factory);
  const Module = factory();
  return Module;
}
// 加载docker配置的远程模块

let readDockerSettingAndLoadResource = async(dockerSeting,routerName) => {

    let dockerSetingDecoded = dockerSeting && JSON.parse(dockerSeting) || '';
    if(dockerSetingDecoded) {
      let {fileName,remoteUrl,modules} = dockerSetingDecoded;
      console.log('dockerSetingDecoded',fileName,remoteUrl,modules)
      fileName =  fileName || 'remoteEntry.js';

      let Module = await loadRemoteComponent(remoteUrl+fileName,modules[routerName]);

      return Module
    }
    else {
      if(!defaultModule) throw('未配置远程资源信息并且无默认模块')
      return defaultModule
    }

  }
// 加载远程页面
  let loadRemotePage = async(pageCode)=> {
      let userNav = store.getters.userNav;
    let filteredPage = userNav.filter(navItem => navItem.pageCode === pageCode)
    let Module = null;
    if(filteredPage && filteredPage.length > 0) {
      let seletedPage = filteredPage[0];
      let {resourceUrl, fileName, moduleName} = seletedPage;
      Module = await loadRemoteComponent(resourceUrl+fileName,moduleName);
    }
    return Module;
  }
  export {loadRemoteComponent,readDockerSettingAndLoadResource,loadRemotePage} ;

